import { render, staticRenderFns } from "./DashboardBs.vue?vue&type=template&id=4b99f392&scoped=true"
import script from "./DashboardBs.vue?vue&type=script&lang=js"
export * from "./DashboardBs.vue?vue&type=script&lang=js"
import style0 from "./DashboardBs.vue?vue&type=style&index=0&id=4b99f392&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b99f392",
  null
  
)

export default component.exports